import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { useParams } from 'react-router-dom'
import { LayoutDashboard } from 'Components/Layout/Dashboard'
import { PageTitle } from 'Components/PageTitle'
import { RosterViewWrapper } from 'Components/Campaigns/RosterView/RosterViewWrapper'
import { HideWhenBlocked } from 'Containers/UIBlock/HideWhenBlocked'
import { getDateOfISOWeek } from './../../../shared/libraries/utils/date'

import ImportMissions from './ImportMissions'
import { showReduxModal, hideReduxModal } from './../../../Reducers/UI/actions'
import {
  convertCreateMissionDtoToMission,
  validateCreateMissionDto,
  downloadSampleCSV,
  canImport,
  getRosterTitle,
  formatDataForComponentConsumption,
  getBreadcrumbs,
} from './util'
import { getDetailsItems } from '../../../Components/DetailsSection/utils'
import ImportButton from './components/ImportButton/ImportButton'
import DetailsSection from '../../../Components/DetailsSection/DetailsSection'
import BreadcrumbsRenderer from '../../../Components/BreadcrumbsRenderer/BreadcrumbsRenderer'
import RosterMissionsTable from '../../../Containers/Campaigns/RosterView/RosterMissionsTable/container/RosterMissionsTable'
import MissionsControls from '../../../Components/MissionsControls/MissionsControls'
import { CAMPAIGN_ENUM_TYPES } from '../../../shared/constants'
import ExportRoster from '../../../Components/ExportRoster'
import { apiClient } from '../../../Module/API/Client'
import { createMissions } from '../../../Module/graphQL'

const countriesShowPayroll = ['BE', 'NL', 'DE']

const RosterView = props => {
  const { rosterId } = useParams()
  const [year, week] = rosterId.split('-')
  const startDate = getDateOfISOWeek(week, year)
  const endDate = new Date(startDate)
  endDate.setDate(endDate.getDate() + 7)

  const [state, setState] = useState({
    cityLocations: [],
    campaign: [],
    cityPlan: {},
    city: {},
    missions: [],
    countryCode: '',
  })

  useEffect(() => {
    setState(
      formatDataForComponentConsumption({
        campaign: props.campaign,
        cityPlan: props.cityPlan,
        rosterId,
      }),
    )
  }, [])

  const {
    cityLocations,
    campaign,
    cityPlan,
    city,
    missions,
    countryCode,
  } = state

  const onMissionsImport = async missionDtos => {
    const locationsHash = {}
    cityLocations.forEach(l => (locationsHash[l.name] = l.id))

    const convertMissionDtoToMission = dto =>
      convertCreateMissionDtoToMission(dto, {
        locations: cityLocations,
      })

    const missions = missionDtos.map(d => ({
      ...convertMissionDtoToMission(d),
      // Add the city plan id
      cityPlanId: cityPlan.id,
    }))

    const allMissions = await createMissions(missions)

    setState(state => ({
      ...state,
      missions: [...state.missions, ...allMissions],
    }))
    props.refetchMissions()
  }

  const showImportMissionsModal = () => {
    const { showReduxModal, hideReduxModal } = props

    const locationNames = cityLocations.map(l => l.name)

    const validateMissionDto = dto =>
      validateCreateMissionDto(dto, {
        locationNames,
        dateRange: [startDate, endDate],
        now: new Date(),
      })

    const downloadCSV = () =>
      downloadSampleCSV({
        locations: cityLocations,
        dateRange: [startDate, endDate],
      })

    const onImportSuccess = data => {
      onMissionsImport(data)
      hideReduxModal()
    }

    showReduxModal({
      hideTitle: true,
      hideButtons: true,
      children: (
        <ImportMissions
          onImportSuccess={onImportSuccess}
          validateRow={validateMissionDto}
          downloadSampleCSV={downloadCSV}
          onClose={hideReduxModal}
        />
      ),
    })
  }

  // Get page's title
  const pageTitle = getRosterTitle(week)
  // Figure out if user should be able to import missions
  const shouldDisplayImportButton = canImport({ week, year })
  // Get details rows that we want to render
  const detailsItemsData = getDetailsItems({
    missions,
    week,
    year,
  })
  // Get breadcrumbs items that we want to render
  const breadcrumbsData = getBreadcrumbs({
    campaign: campaign,
    cityPlanId: props.match.params.cityPlanId,
    campaignId: props.match.params.campaignId,
    fromCityScreen: props.location.fromCityScreen,
    city: city,
  })

  const onDelete = async deletedId => {
    const payload = {
      unbookReason: undefined,
      missions: [{ id: deletedId }],
    }

    setState(state => ({
      ...state,
      missions: state.missions.filter(({ id }) => id != deletedId),
    }))

    await apiClient.deleteMissions(payload)
  }

  return (
    <HideWhenBlocked>
      <RosterViewWrapper>
        <LayoutDashboard>
          <BreadcrumbsRenderer
            icon={breadcrumbsData.icon}
            items={breadcrumbsData.items}
          />
          <PageTitle>{pageTitle}</PageTitle>
          <MissionsControls
            missions={missions}
            campaign={campaign}
            updateData={() => props.refetchMissions()}
          />
          <DetailsSection items={detailsItemsData} />
          <section style={buttonsContainerStyle}>
            <ImportButton
              hidden={
                !shouldDisplayImportButton ||
                campaign.type === CAMPAIGN_ENUM_TYPES.DIRECTMAIL
              }
              onClick={showImportMissionsModal}
            />
            {campaign.type === CAMPAIGN_ENUM_TYPES.HANDTOHAND &&
              countriesShowPayroll.includes(countryCode) && (
                <ExportRoster
                  campaignId={campaign.id}
                  cityId={city.id}
                  startDate={startDate}
                  endDate={endDate}
                  filename={`${campaign.name} - ${pageTitle} - ${year}`}
                />
              )}
          </section>
          <RosterMissionsTable {...props} {...state} onDelete={onDelete} />
        </LayoutDashboard>
      </RosterViewWrapper>
    </HideWhenBlocked>
  )
}

const mapDispatchToProps = {
  showReduxModal,
  hideReduxModal,
}
const mapStateToProps = state => ({
  dayPeriodFilter: state.missions.missionsDayPeriodFilter,
  sortBy: state.missions.rosterViewMissionsSortBy,
  statusFilter: state.missions.missionsStatusFilter,
  typeFilter: state.missions.missionsTypeFilter,
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(RosterView)

const buttonsContainerStyle = {
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
}



// WEBPACK FOOTER //
// ./src/Containers/Campaigns/RosterView/index.js